// Hazard-tape band angled 45° across a card image — seals off SOLD OUT items.
export default function SoldTape({ testid = "sold-tape" }) {
  return (
    <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center overflow-hidden" data-testid={testid}>
      <div className="hazard-stripes absolute left-[-20%] w-[140%] rotate-[-45deg] py-3 shadow-lg" />
      <span className="relative z-10 rotate-[-45deg] bg-black px-3 py-1 font-mono text-xs font-bold uppercase tracking-[0.3em] text-yaza-accent">
        Sold Out
      </span>
    </div>
  );
}
